module.exports = __webpack_public_path__ + "img/design proposal_demo-08.b2a9336c.jpg";